export default __webpack_public_path__ + "static/media/pincho-hombre-pelirrojo.bc1c87fe.png";